import { Injectable } from '@angular/core';
import AgoraRTC from 'agora-rtc-sdk';
import { BehaviorSubject } from 'rxjs';
import { RecordingService } from './recording-service.interface';
import { RecordingStates } from './recording-states';

@Injectable({
  providedIn: 'root',
})
export class AgoraRecorderService extends RecordingService {
  private client: any;
  private stream: any;
  private channelName = 'pwebchannel';
  private streamId = 'pwebstream';
  private uidVal = 0;
  private apptoken = null;

  private streamAudioDevices = new BehaviorSubject([]);

  constructor(args: any) {
    super(args);
    this.client = AgoraRTC.createClient({ mode: 'live', codec: 'h264' });
  }

  preInit() {}

  init() {
    return new Promise((resolve, error) => {
      this.client.init(
        this.args.audioId,
        () => {
          this.client.setClientRole('host');
          resolve(true);
        },
        (err) => error('client init failed: ' + err),
      );
    });
  }

  async start(microphoneId: string): Promise<void> {
    await this.joinChannel();
    const localStream = await this.createStream(microphoneId);
    this.publishStream(localStream);
    this.stream = localStream;
    this.listenStreamAdded();
    this.isRecording = true;
  }

  play() {
    if (this.stream && this.stream.hasAudio()) {
      this.stream.unmuteAudio();
      this.streamStateSubject.next(RecordingStates.PLAYING);
    }
  }

  pause() {
    if (this.stream && this.stream.hasAudio()) {
      this.stream.muteAudio();
      this.streamStateSubject.next(RecordingStates.PAUSED);
    }
  }

  stop() {
    if (this.isRecording && this.stream) {
      this.stream.close();
      this.leaveChannel().then(() => {
        this.streamStateSubject.next(RecordingStates.STOPED);
        this.isRecording = false;
      });
    }
  }

  getInputDevices() {
    this.client.getRecordingDevices((devices) => {
      const objDevices = {};
      const finalDevices = [];
      for (const device of devices) {
        objDevices[device.groupId] = device;
      }
      const keys = Object.keys(objDevices);
      for (const key of keys) {
        finalDevices.push(objDevices[key]);
      }
      this.streamAudioDevices.next(finalDevices);
    });

    return this.streamAudioDevices.asObservable();
  }

  private joinChannel() {
    console.log('appToken: ' + this.apptoken);
    return new Promise((resolve, error) => {
      this.client.join(
        this.apptoken,
        this.channelName,
        this.uidVal,
        (uid) => {
          this.uidVal = uid;
          console.log('join channel:  success, uid: ' + uid);
          resolve(true);
        },
        (err) => error('client join failed: ' + err),
      );
    });
  }

  private createStream(microphoneId: string) {
    return new Promise((resolve, error) => {
      const localStream = AgoraRTC.createStream({
        streamID: this.streamId,
        audio: true,
        video: false,
        screen: false,
        microphoneId,
      });

      localStream.init(
        () => {
          console.log('init local stream sucess');
          resolve(localStream);
        },
        (err) => error('init local stream failed: ' + err),
      );
    });
  }

  private publishStream(localStream: any) {
    this.client.publish(localStream, (err) => {
      console.log('publish failed');
      console.error('publish failed: ' + err);
    });
  }

  private listenStreamAdded() {
    this.client.on('stream-published', (evt) => {
      console.log('new stream added ');
      this.streamReadySubject.next();
      this.streamStateSubject.next(RecordingStates.PLAYING);
    });
  }

  private leaveChannel() {
    return new Promise((resolve, error) => {
      this.client.leave(
        () => resolve(true),
        (err) => error('client leave failed: ' + err),
      );
    });
  }
}
